import { ReactElement, useState } from 'react';

import {
  AccountCircleOutlined as AccountCircleOutlinedIcon,
  AccountCircleTwoTone as AccountCircleTwoToneIcon
} from '@mui/icons-material';
import { useTheme, useMediaQuery, Button } from '@mui/material';

import UserPopover from './components/UserPopover';
import { UserProps } from './types';

import { useBoolean, useSelector } from '../../../../../../common/hooks';
import IconButton from '../../../../../../components/IconButton';
import LoginModal from '../../../../../../components/LoginModal';
import { Anchor } from '../../types';

export default function User({ invert }: UserProps): ReactElement {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('md'));

  const user = useSelector((state) => state.user);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [anchorEl, setAnchorEl] = useState<Anchor>(null);

  const [open, setOpen] = useBoolean();

  return (
    <>
      {!isSm ? (
        <Button
          color={user.data.loggedIn ? (anchorEl ? 'primary' : 'secondary') : 'primary'}
          startIcon={
            user.data.loggedIn ? (
              anchorEl ? (
                <AccountCircleTwoToneIcon />
              ) : (
                <AccountCircleOutlinedIcon />
              )
            ) : undefined
          }
          onClick={
            user.data.loggedIn ? (event) => setAnchorEl(event.currentTarget) : () => setOpen.on()
          }
          variant='contained'>
          {user.data.loggedIn ? user.data.fullname : 'Log In'}
        </Button>
      ) : (
        <IconButton
          aria-label='User'
          color={user.data.loggedIn ? (anchorEl ? 'primary' : 'secondary') : 'secondary'}
          onClick={
            user.data.loggedIn ? (event) => setAnchorEl(event.currentTarget) : () => setOpen.on()
          }
          variant='icon'
          sx={!invert ? { color: `${theme.palette.grey[50]} !important` } : {}}>
          {open || anchorEl ? <AccountCircleTwoToneIcon /> : <AccountCircleOutlinedIcon />}
        </IconButton>
      )}

      {user.data.loggedIn ? (
        <UserPopover anchorEl={anchorEl} onClose={() => setAnchorEl(null)} />
      ) : (
        <LoginModal open={open} onClose={() => setOpen.off()} />
      )}
    </>
  );
}
